import { log } from 'utils';
import React, { Component } from 'react';
import {IMG_URL} from '../img/hosted_images'

class FeedbackForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // feeback: false,
      feebackRating: 'good'
      // comment : ''
    };

    this.toggleIcon = this.toggleIcon.bind(this);
    this.validateFeedback = this.validateFeedback.bind(this);
    // this.handleCommentChange = this.handleCommentChange.bind(this);
  }


// handleCommentChange(e){

//   this.setState({
//     comment:e.target.value
// });

// }



  toggleIcon(ev) {
    let redSmiley = document.getElementById('ebcss-smile-red'),
      orangeSmiley = document.getElementById('ebcss-smile-orange'),
      greenSmiley = document.getElementById('ebcss-smile-green');

    // reset all icons
    // redSmiley.src = '../img/ic_smiley_sad_line.png';
    // orangeSmiley.src = '../img/ic_smiley_neutral_line.png';
    // greenSmiley.src = '../img/ic_smiley_happy_line.png';

    if (ev.target.classList.contains('ebcss-smile-red')) {
      if (ev.target.src.includes('fill')) {
        ev.target.src = IMG_URL +'/ic_smiley_sad_line.png';
        // this.setState({
        //   feeback: false
        // });
        this.props.onChangeFeedback(false)
      } else {
        ev.target.src = IMG_URL +'/ic_smiley_sad_fill.png';
        this.props.onFeedbackRatingUpdate('bad');
        // this.setState({
        //   feeback: true
        // });
        this.props.onChangeFeedback(true)
      }
      orangeSmiley.src = IMG_URL +'/ic_smiley_neutral_line.png';
      greenSmiley.src = IMG_URL +'/ic_smiley_happy_line.png';
    } else if (ev.target.classList.contains('ebcss-smile-orange')) {
      if (ev.target.src.includes('fill')) {
        ev.target.src = IMG_URL +'/ic_smiley_neutral_line.png';
        // this.setState({
        //   feeback: false
        // });
        this.props.onChangeFeedback(false)
      } else {
        ev.target.src = IMG_URL +'/ic_smiley_neutral_fill.png';
        this.props.onFeedbackRatingUpdate('good');
        // this.setState({
        //   feeback: true
        // });
        this.props.onChangeFeedback(true)
      }
      redSmiley.src = IMG_URL +'/ic_smiley_sad_line.png';
      greenSmiley.src = IMG_URL +'/ic_smiley_happy_line.png';
    } else if (ev.target.classList.contains('ebcss-smile-green')) {
      if (ev.target.src.includes('fill')) {
        ev.target.src = IMG_URL +'/ic_smiley_happy_line.png';
        // this.setState({
        //   feeback: false
        // });
        this.props.onChangeFeedback(false)

      } else {
        ev.target.src = IMG_URL +'/ic_smiley_happy_fill.png';
        this.props.onFeedbackRatingUpdate('good');
        // this.setState({
        //   feeback: true
        // });
        this.props.onChangeFeedback(true)

      }
      redSmiley.src = IMG_URL +'/ic_smiley_sad_line.png';
      orangeSmiley.src = IMG_URL +'/ic_smiley_neutral_line.png';
    } else {
      log('Something went wrong. Please try again');
    }

    let errMsgContainer = document.getElementsByClassName(
      'ebcss-feedback-error-msg'
    )[0];
    errMsgContainer.innerHTML = '';


  }

  validateFeedback() {
    let errMsgContainer = document.getElementsByClassName(
      'ebcss-feedback-error-msg'
    )[0];
    
    if (this.props.feedback) {
      errMsgContainer.innerHTML = '';
      this.props.onFeedbackUpdate(document.getElementById('ebcss-comment').value);
      // this.setState({
      //   // comment : '',
      //   feeback : false
      // });
      this.props.onChangeFeedback(false)
    } else {
      errMsgContainer.innerHTML =
        'Bitte wählen Sie ein Emoticon aus und hinterlassen Sie wenn Sie möchten einen Kommentar.';
    }
    return;
  }


  render() {
    const class_name = [
      'ebcss-feeback-form-container',
      this.props.addClass
    ].join(' ');
    return (
      <div className={class_name}>
        <div className="ebcss-feedback-message-main-wrapper">
          <div className="ebcss-feedback-header">
            <h1>Warst Du mit dem Service unserer digitalen Assistentin zufrieden?</h1>
            <h6 className="ebcss-feedback-error-msg"></h6>
          </div>
          <div className="ebcss-feedback-icon-image">
            <div className="ebcss-feedback-icon">
              <img
                className="ebcss-image ebcss-smile-red"
                id="ebcss-smile-red"
                onClick={this.toggleIcon}
                src={IMG_URL + '/ic_smiley_sad_line.png'}
                ref="redSmiley"
              />
            </div>
            <div className="ebcss-feedback-icon">
              <img
                className="ebcss-image ebcss-smile-orange"
                id="ebcss-smile-orange"
                onClick={this.toggleIcon}
                src={IMG_URL + '/ic_smiley_neutral_line.png'}
                ref="orangeSmiley"
              />
            </div>
            <div className="ebcss-feedback-icon">
              <img
                className="ebcss-image ebcss-smile-green"
                id="ebcss-smile-green"
                onClick={this.toggleIcon}
                src={IMG_URL + '/ic_smiley_happy_line.png'}
                ref="greenSmiley"
              />
            </div>
            <div className="ebcss-feedback-input-area form-group">
              <textarea
                className="form-control ebcss-feedback-input"
                rows="5"
                id="ebcss-comment"
                // value={this.state.comment}
                placeholder="Kommentar"
                // onChange={this.handleCommentChange}
              ></textarea>
            </div>
            <div className="ebcss-button-wrapper ebcss-feedback-btn-div">
              <button
                className="ebcss-btn ebcss-feedback-submit-btn"
                id="ebcss-feedback-submit-btn"
                onClick={this.validateFeedback}
              >
              Feedback senden
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FeedbackForm.displayName = 'FeedbackForm';
FeedbackForm.propTypes = {
  addClass: React.PropTypes.string
};

export default FeedbackForm;



// WEBPACK FOOTER //
// ./src/components/FeedbackForm.js